import React from 'react';
import { useParams } from 'react-router-dom';

import Slider from '../../components/Slider';
import { useData } from '../../hooks';

import Composer from './slides/Composer';
import Concert from './slides/Concert';
import Musicians from './slides/Musicians';
import Project from './slides/Project';
import { StyledShadowContainer } from './styled';

const About = () => {
  let options = {
    initialSlide: 0,
  };

  const { details = [] } = useData();
  const params = useParams();

  const components = [Project, Concert, Composer, Musicians];

  const slides = details.map((detail, index) => {
    if (detail.id === params.aboutId) {
      options = {
        ...options,
        initialSlide: index,
      };
    }
    const Component = components[index];
    return <Component key={detail.id} {...detail} index={index} />;
  });

  return (
    <StyledShadowContainer>
      <Slider options={options} slides={slides} />
    </StyledShadowContainer>
  );
};

export default About;
